import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminChangeLogAsync } from '../../ajax/requests';
import ChangeLogTable from '../../components/ChangeLogTable.tsx';
import { DateField, FormField, TextInputField } from '../../components/Forms/fields';
import Typography from '../../components/Typography';
import { loadEntities } from '../../store/entities/actions';
import { useEntities } from '../../store/entities/hooks';
import { isLoadingEntities } from '../../store/entities/selectors';
import { ChangeLogEntity } from '../../store/entities/state';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import './AdministratorDashboard.scss';
import { getNowDateString } from '../../shared/utils';

export const ChangeLogTab = () => {
  const t = useTranslations()
  const dispatch = useDispatch()
  const changes = useEntities<ChangeLogEntity>('changeLogs')
  const loading = useSelector(isLoadingEntities('changeLogs'))
  const [filter, setFilter] = useState('')

  const [date, setDate] = useState<string>(getNowDateString())
  const changesSelectedDate = React.useMemo(() => changes.filter(c => c.timestamp.startsWith(date)).reverse(), [date, changes])

  useEffect(() => {
    dispatch(loadEntities('changeLogs', () => getAdminChangeLogAsync(date, date), 'AppendResult', changesSelectedDate.map(x => x.id)))
  }, [date])

  const filteredChangeLog = filter.length === 0 
    ? changesSelectedDate 
    : changesSelectedDate.filter(v => JSON.stringify(v).toLowerCase().includes(filter.toLowerCase()))

  return (<>
    <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacer-S)'}}>
      <DateField label={t(TK.data)} type='date' value={date} onChange={setDate} />
      <TextInputField label={t(TK.filter)} value={filter} onChange={setFilter} />
    </div>
    <Typography style={{visibility: loading ? 'unset':'hidden'}}>{t(TK.loading)}</Typography>
    <ChangeLogTable showDate={false} showTime={true} changeLog={filteredChangeLog}/>
  </>)
} 